
// Opciones de Medio (source/medium) para reportes y otras pantallas
export const ROLES_OPTIONS = [
  { value: 'ADMIN', label: 'Administrador' },
  { value: 'ASISTENTE', label: 'Asistente' },
];

// Opciones de Medio (source/medium) para reportes y otras pantallas
export const SPLASH_ROLES_OPTIONS = [
  { value: 'TODOS', label: 'Todos' },
  { value: 'ESPECIALISTA', label: 'Especialista' },
  { value: 'CLIENTE', label: 'Paciente' },
];

// Función helper para obtener el label de un rol dado su value
export const getRoleLabel = (roleValue) => {
  const role = ROLES_OPTIONS.find(r => r.value === roleValue);
  return role ? role.label : roleValue;
};

// Meses del año para filtros de cumpleaños
export const MONTHS_OPTIONS = [
  { value: 1, label: 'Enero' },
  { value: 2, label: 'Febrero' },
  { value: 3, label: 'Marzo' },
  { value: 4, label: 'Abril' },
  { value: 5, label: 'Mayo' },
  { value: 6, label: 'Junio' },
  { value: 7, label: 'Julio' },
  { value: 8, label: 'Agosto' },
  { value: 9, label: 'Septiembre' },
  { value: 10, label: 'Octubre' },
  { value: 11, label: 'Noviembre' },
  { value: 12, label: 'Diciembre' },
];


export const GENDER_OPTIONS = [
  { value: 'MASCULINO', label: 'Masculino' },
  { value: 'FEMENINO', label: 'Femenino' },
];

export const BLOOD_TYPE_OPTIONS = [
  { value: 'A+', label: 'A+' },
  { value: 'A-', label: 'A-' },
  { value: 'B+', label: 'B+' },
  { value: 'B-', label: 'B-' },
  { value: 'AB+', label: 'AB+' },
  { value: 'AB-', label: 'AB-' },
  { value: 'O+', label: 'O+' },
  { value: 'O-', label: 'O-' },
];